import { getCookie } from '@/src/utils/browser'
import { parseAbCookie, type AbCookieConfig } from './index'

const AB_COOKIE_NAME = 'ct-ab'

export const getAbFromCookie = (): AbCookieConfig | null => {
    if (typeof window === 'undefined') return null
    return parseAbCookie(getCookie(AB_COOKIE_NAME))
}
